import React from 'react'

export function runTimestamp(run: any): string | undefined {
  return run?.started_at || run?.created_at
}

export function runTriggerLabel(run: any): string {
  return run?.trigger_type === 'manual' || run?.trigger_type === 'Manual' ? 'Manual' : 'Scheduled'
}

export function runStatusLabel(status: string): string {
  if (status === 'running') return 'Running'
  if (status === 'success') return 'Success'
  if (status === 'failed') return 'Failed'
  return status || 'Unknown'
}

function statusBadgeClass(status: string): string {
  if (status === 'success') return 'tw-bg-green-100 tw-text-green-800'
  if (status === 'failed') return 'tw-bg-red-100 tw-text-red-800'
  if (status === 'running') return 'tw-bg-blue-100 tw-text-blue-800'
  return 'tw-bg-slate-100 tw-text-slate-700'
}

export function RunStatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-medium ${statusBadgeClass(status)}`}
    >
      {status === 'running' && (
        <span className="fa fa-spinner fa-spin tw-text-[10px]" aria-hidden />
      )}
      {runStatusLabel(status)}
    </span>
  )
}

export function RunTriggerBadge({ run }: { run: any }) {
  return (
    <span className="tw-inline-flex tw-rounded-full tw-bg-slate-100 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-medium tw-text-slate-600">
      {runTriggerLabel(run)}
    </span>
  )
}

